import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";

export class PlanningTimelineFiltersPanelComponent implements IController {

  skills: any;
  routes: any;
  routesOptions: any;
  onFiltersChange: Function;

  /* @ngInject */
  constructor(private $mdPanel, private agentConstants) {
  }

  $onInit() {
  }

  ///////////////////////////////////////////////////////////
  ///////////////////  Public Functions ////////////////////
  //////////////////////////////////////////////////////////

  hasFilters() {
    return (!!_.get(this.skills, 'length') && (this.skills.length !== this.agentConstants.skills.length)) ||
      (this.routes.length !== this.routesOptions.length);
  }


  onShowPanel($event) {

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_END,
        this.$mdPanel.yPosition.ALIGN_TOPS // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.planning-timeline-filters-btn')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          skills: this.skills || [],
          routes: this.routes || [],
          routesOptions: this.routesOptions || [],
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DeliveriesPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/planning/components/planning-timeline-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      skills: filterConfig.skills,
      routes: filterConfig.routes
    })
  }
}

class DeliveriesPanelCtrl implements IController {

  public filterConfig: any;
  public skillsOptions: any;
  public routesOptions: any;

  constructor(private mdPanelRef, private $mdSelect, private $q: IQService, private agentConstants) {

    this.filterConfig = {
      skills: angular.copy(mdPanelRef.config.locals.data.skills),
      routes: angular.copy(mdPanelRef.config.locals.data.routes)
    };
    this.skillsOptions =  this.agentConstants.skills || [];
    this.routesOptions = mdPanelRef.config.locals.data.routesOptions;
  }

  $onInit() {
  }

  onChangeSkills(selectedSkills) {
    this.filterConfig.skills = selectedSkills;
    this.routesOptions =_.filter(this.mdPanelRef.config.locals.data.routes, (r) => {
      const routeAllocationSkills = _.get(r, 'resource.allocationSkills', []);
      return !this.filterConfig.skills || !_.isEmpty(_.intersection(this.filterConfig.skills, routeAllocationSkills));
    })

    this.filterConfig.routes = angular.copy(this.routesOptions);
  }

  onChangeRoutes(routes) {
    this.filterConfig.routes = routes;
  }

  resetRoutes() {
    this.filterConfig.routes = [];
    this.$mdSelect.hide();
  }

  cancelRoutes() {
    this.$mdSelect.hide();
  }

  selectRoutes(routes) {
    this.filterConfig.routes = routes;
    this.$mdSelect.hide();
  }

  onReset() {
    this.filterConfig = {
      skills: [],
      routes: []
    };
    this.submit();
  }


  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.filterConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }


  cancel() {
    this.mdPanelRef.close();
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningTimelineFiltersPanel', {
    bindings: {
      skills: '<',
      routes: '<',
      routesOptions: '<',
      onFiltersChange: '&'
    },
    template: require('./planning-timeline-filters-panel.html').default,
    controller: PlanningTimelineFiltersPanelComponent
  });
